// リサイズされたら強制リロード
const innerWidth = window.innerWidth

window.addEventListener('resize', function () {
  console.log(this.innerWidth)
  if (this.innerWidth != innerWidth) {
    location.reload()
  }
})

fvSlider()
function fvSlider() {
  const fv = document.querySelector('#fv')
  const contentWrapper = document.querySelector('#fv .content')
  const sliderWrapper = document.querySelector('.fv__slider')
  const fvTitle = document.querySelector('#fv h1')
  const fvSpacingWidth = (window.innerWidth - contentWrapper.clientWidth) / 2
  const slideWidth =
    contentWrapper.scrollWidth - fvTitle.scrollWidth + fvSpacingWidth
  const slider = new Splide(sliderWrapper, {
    type: 'loop',
    pagination: false,
    arrows: false,
    autoWidth: true,
    fixedHeight: `${fv.clientHeight}px`,
    gap: '1.6rem',
    pauseOnFocus: false,
    pauseOnHover: false,
    drag: false,
    autoScroll: {
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 0.8,
    },
    mediaQuery: 'max',
    breakpoints: {
      749: {
        fixedHeight: `60vh`,
      },
    },
  })

  // スライダーのサイズを設定
  sliderWrapper.style.width = `calc(${slideWidth}px - 12rem)`

  // スライダーのマウント
  slider.mount(window.splide.Extensions)
}

mealsSlider()
function mealsSlider() {
  const slides = document.querySelectorAll('.slider-wrapper')

  slides.forEach((elm, index) => {
    const slide = document.querySelector(
      `.${elm.className} .splide.splide--${index + 1}`
    )
    const prevButton = document.querySelector(
      `.${elm.className} .slider-prev.slider-prev--${index + 1}`
    )
    const nextButton = document.querySelector(
      `.${elm.className} .slider-next.slider-next--${index + 1}`
    )

    const splide = new Splide(slide, {
      type: 'loop',
      arrows: false,
      pagination: false,
      gap: '3.2rem',
    })

    splide.mount()

    prevButton.addEventListener('click', () => {
      splide.go('<')
    })
    nextButton.addEventListener('click', () => {
      splide.go('>')
    })
  })
}